import { z } from 'zod';
import { SanityDocumentSchema, SanityReferenceSchema, SanitySlugSchema } from '../sanity';
import { EntityType } from '$lib/sanity/types';
import { NewsTopicSchema } from './NewsTopic';
import { ColorsSchema } from '../shared';
import { SEOSchema } from '../shared/SEO';

export const NewsShapeUnion = z.union([
  z.literal('clover'),
  z.literal('halfPill'),
  z.literal('hexagon'),
  z.literal('oval'),
  z.literal('triangle'),
  z.literal('circle')
]);

export const NewsTagSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.NewsTag),
  name: z.string(),
  category: z.string().nullish(),
  slug: SanitySlugSchema,
  topics: z.array(SanityReferenceSchema.or(NewsTopicSchema)).nullish(),
  shape: NewsShapeUnion.nullish(),
  colors: ColorsSchema.nullish(),
  seoAttributes: SEOSchema.nullish()
});

export const NewsTagArraySchema = z.array(NewsTagSchema);

export type NewsShape = z.infer<typeof NewsShapeUnion>;
export type NewsTag = z.infer<typeof NewsTagSchema>;
export type NewsTagArray = z.infer<typeof NewsTagArraySchema>;
